import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";

export function render(opts: {}): HTMLElement | HTMLElement[] {
  // Not used atm
  return <span></span>;
}
